"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _UserAgent = require("../utils/UserAgent");

var _CordovaFileHelper = _interopRequireDefault(require("../helpers/CordovaFileHelper"));

/* eslint-disable promise/avoid-new */
var FileTransferWrapper = /*#__PURE__*/function () {
  function FileTransferWrapper() {
    (0, _classCallCheck2["default"])(this, FileTransferWrapper);
    this.fileTransfer = new window.FileTransfer();
  }
  /**
   * If loading from akamai the cookies have to be disabled in XCode.
   */


  (0, _createClass2["default"])(FileTransferWrapper, [{
    key: "downloadWithJS",
    value: function () {
      var _downloadWithJS = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(remoteFile, localFilename, localFolder, onProgress, trustAllHosts, setCancelFn) {
        var options,
            method,
            setUserAgent,
            files,
            fileEntry,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 6 && _args[6] !== undefined ? _args[6] : {};
                method = _args.length > 7 && _args[7] !== undefined ? _args[7] : 'GET';
                setUserAgent = _args.length > 8 && _args[8] !== undefined ? _args[8] : false;
                files = _args.length > 9 && _args[9] !== undefined ? _args[9] : null;
                _context.next = 6;
                return _CordovaFileHelper["default"].getFileEntry(localFilename, localFolder, true);

              case 6:
                fileEntry = _context.sent;
                return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var oReq = new window.XMLHttpRequest(); // this function can be called from outside to cancel the download

                  if (setCancelFn) {
                    setCancelFn(oReq.abort);
                  } // Make sure you add the domain name to the Content-Security-Policy <meta> element.


                  oReq.open(method, remoteFile, true);
                  var data = null;

                  if (method === 'POST') {
                    data = "files=".concat(files.map(function (entry) {
                      return entry.fileName;
                    }).join(',')); // data = new window.FormData()
                    // data.append('ids', )

                    oReq.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                  }

                  if (options && options.headers && options.headers['Authorization']) {
                    oReq.setRequestHeader('Authorization', options.headers['Authorization']);
                  }

                  if (setUserAgent) {
                    oReq.setRequestHeader('User-Agent', (0, _UserAgent.getUserAgent)());
                  } // Define how you want the XHR data to come back


                  oReq.responseType = 'blob';

                  if (onProgress) {
                    oReq.onprogress = onProgress;
                  }

                  oReq.onload = function (oEvent) {
                    var blob = oReq.response; // Note: not oReq.responseText

                    if (blob) {
                      fileEntry.createWriter(function (fileWriter) {
                        var written = 0;
                        var startTime = new Date().getTime();
                        var BLOCK_SIZE = 1 * 1024 * 1024; // write 1M every time of write

                        function writeNext(cbFinish) {
                          fileWriter.onwrite = function (evt) {
                            if (written < blob.size) {
                              writeNext(cbFinish);
                            } else {
                              cbFinish();
                            }
                          };

                          if (written) {
                            fileWriter.seek(fileWriter.length);
                          }

                          fileWriter.write(blob.slice(written, written + Math.min(BLOCK_SIZE, blob.size - written)));
                          written += Math.min(BLOCK_SIZE, blob.size - written);
                          var time2 = new Date().getTime() - startTime;
                          console.log("wrote part, now at ".concat(written, ", took ").concat(time2, " ms"));
                        }

                        writeNext(function () {
                          var endTime = new Date().getTime();
                          console.log("Successfully downloaded ".concat(remoteFile, " to ").concat(localFilename, ", writing progress took ").concat(endTime - startTime, " ms"));
                          resolve(fileEntry);
                        }); // fileWriter.onwriteend = function () {
                        //
                        // }

                        fileWriter.onerror = function (e) {
                          console.log('Failed file write: ' + e.toString());
                          reject(e);
                        }; // fileWriter.write(blob)

                      });
                    } else {
                      console.error('we didnt get an XHR response!');
                      reject(new Error('we didnt get an XHR response!'));
                    }
                  };

                  oReq.send(data);
                }));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function downloadWithJS(_x, _x2, _x3, _x4, _x5, _x6) {
        return _downloadWithJS.apply(this, arguments);
      }

      return downloadWithJS;
    }()
  }, {
    key: "download",
    value: function () {
      var _download = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(remoteFile, localPath, onProgress, trustAllHosts, options) {
        var _this = this;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("downloading ".concat(remoteFile, " to ").concat(localPath));

                if (onProgress) {
                  this.fileTransfer.onprogress = onProgress;
                }

                return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var successCallback = function successCallback(fileEntry) {
                    console.log("done downloading ".concat(remoteFile, " to ").concat(localPath));
                    resolve(fileEntry);
                  };

                  var errorCallback = function errorCallback(error) {
                    reject(error);
                  };

                  var optionsToUse = options || {};

                  if (!optionsToUse.headers) {
                    optionsToUse.headers = {};
                  }

                  optionsToUse.headers['User-Agent'] = (0, _UserAgent.getUserAgent)();

                  _this.fileTransfer.download(remoteFile, localPath, successCallback, errorCallback, trustAllHosts, optionsToUse);
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function download(_x7, _x8, _x9, _x10, _x11) {
        return _download.apply(this, arguments);
      }

      return download;
    }()
  }]);
  return FileTransferWrapper;
}();

var _default = FileTransferWrapper;
exports["default"] = _default;